import { render, staticRenderFns } from "./Rimix.vue?vue&type=template&id=98284cd6&lang=pug"
import script from "./Rimix.vue?vue&type=script&lang=js"
export * from "./Rimix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports